import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  Chip,
  CircularProgress,
  Alert,
} from '@mui/material';
import {
  PlayArrow,
  CheckCircle,
  AccessTime,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import quizAPI from '../../services/quizAPI';

const MyQuizzes = () => {
  const navigate = useNavigate();
  const [quizzes, setQuizzes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchQuizzes();
  }, []);

  const fetchQuizzes = async () => {
    try {
      setLoading(true);
      setError('');
      
      console.log('📚 Fetching available quizzes...');
      const response = await quizAPI.getAll({ status: 'published' });
      console.log('✅ Quizzes:', response);
      
      const quizList = response.quizzes || response.data?.quizzes || [];
      setQuizzes(quizList);
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Erreur lors du chargement des quiz';
      setError(errorMsg);
      toast.error(errorMsg);
      console.error('❌ My quizzes error:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Quiz Disponibles
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Grid container spacing={3}>
        {quizzes.length === 0 ? (
          <Grid item xs={12}>
            <Card>
              <CardContent sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="h6" color="text.secondary" gutterBottom>
                  Aucun quiz disponible
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Votre formateur n'a pas encore publié de quiz.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ) : (
          quizzes.map((quiz) => (
            <Grid item xs={12} md={6} lg={4} key={quiz._id}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    {quiz.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {quiz.description}
                  </Typography>
                  
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
                    <Chip
                      icon={<CheckCircle />}
                      label={`${quiz.questions?.length || 0} questions`}
                      size="small"
                      variant="outlined"
                    />
                    <Chip
                      icon={<AccessTime />}
                      label={`${quiz.duration} min`}
                      size="small"
                      variant="outlined"
                    />
                    <Chip
                      label={`Seuil: ${quiz.passingScore}%`}
                      size="small"
                      color="primary"
                      variant="outlined"
                    />
                  </Box>

                  {quiz.maxAttempts && (
                    <Typography variant="caption" color="text.secondary" display="block">
                      Maximum {quiz.maxAttempts} tentative(s)
                    </Typography>
                  )}
                </CardContent>
                
                <Box sx={{ p: 2, pt: 0 }}>
                  <Button
                    variant="contained"
                    fullWidth
                    startIcon={<PlayArrow />}
                    onClick={() => navigate(`/quiz/${quiz._id}`)}
                  >
                    Passer le Quiz
                  </Button>
                </Box>
              </Card>
            </Grid>
          ))
        )}
      </Grid>
    </Box>
  );
};

export default MyQuizzes;

